exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__information___19xGY {\n  height: 255px;\n  padding: 15px 25px 15px 25px;\n  position: relative; }\n\n.style__informationName___2lyFe {\n  font-size: 28px;\n  margin-top: 5px;\n  margin-bottom: 20px;\n  color: #434343; }\n\n.style__informationDescription___ZfSu- {\n  color: #999;\n  font-weight: lighter; }\n\n.style__informationAuthor___KRA0K strong {\n  font-weight: bolder; }\n\n.style__informationVersion___34VMS {\n  color: #999;\n  margin-bottom: 5px; }\n\n.style__informationLicense___g4yLA a:hover {\n  color: #58d1b0; }\n\n.style__whereFrom___1KSPf {\n  position: absolute;\n  bottom: 5px;\n  right: 15px;\n  font-size: 12px;\n  color: #bfbfbf; }\n", ""]);

// exports
exports.locals = {
	"information": "style__information___19xGY",
	"informationName": "style__informationName___2lyFe",
	"informationDescription": "style__informationDescription___ZfSu-",
	"informationAuthor": "style__informationAuthor___KRA0K",
	"informationVersion": "style__informationVersion___34VMS",
	"informationLicense": "style__informationLicense___g4yLA",
	"whereFrom": "style__whereFrom___1KSPf"
};